// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "SelfServMeta" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { HeaderAlignment } from "./header-alignment.enum.gen";
import { ThemeGenShape } from "./theme.gen";
import { TreeStatus } from "./tree-status.enum.gen";
import { TreeType } from "./tree-type.enum.gen";
import { SelfServContactInfoGenShape } from "./self-serv-contact-info.gen";
import { SelfServMetaStatus } from "./self-serv-meta-status.enum.gen";

export const SelfServMetaGenShape = z.strictObject({
  configId: z.string(),
  headerAlignment: z.enum(HeaderAlignment),
  customCss: z.string().optional(),
  theme: ThemeGenShape.optional(),
  teamName: z.string().optional(),
  fullCouncilName: z.string().optional(),
  logoImage: z.string().optional(),
  headerImage: z.string().optional(),
  teamId: z.string(),
  domain: z.string(),
  treeStatus: z.enum(TreeStatus),
  treeType: z.enum(TreeType),
  homeLink: z.string().optional(),
  housingLink: z.string().optional(),
  feedbackLink: z.string().optional(),
  privacyLink: z.string().optional(),
  contactLink: z.string().optional(),
  hideContactBtn: z.boolean(),
  treeId: z.string(),
  treeName: z.string().optional(),
  serviceName: z.string().optional(),
  description: z.string().optional(),
  contact: SelfServContactInfoGenShape.optional(),
  libraryId: z.string(),
  created: z.string(),
  metaStatus: z.enum(SelfServMetaStatus),
  url: z.string().optional(),
  dataUrl: z.string().optional(),
  eTag: z.string(),
  gaKey: z.string().optional(),
  hotjarId: z.number().optional(),
  disclaimer: z.string().optional(),
  showFeedback: z.boolean(),
  errors: z.array(z.string()).optional(),
  lastEdited: z.string().optional(),
  id: z.string(),
});
